// https://newsapi.org/v2/everything?q=tesla&from=2023-04-21&sortBy=publishedAt&apiKey=8df726173b81413db6b74770e308729c

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { NewsApiType } from '../../types';

export const newsApi = createApi({
  reducerPath: 'newsApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: 'https://newsapi.org/v2/',
    headers: { 'X-Api-Key': process.env.REACT_APP_NEWS_API_KEY || ''} }), 
  endpoints: (builder) => ({
    getNewsApi: builder.query<NewsApiType, string>({
      query: () => `/everything?q=reactjs&from=2023-04-21&sortBy=publishedAt&apiKey=${process.env.REACT_APP_NEWS_API_KEY}`,
    }),
  }),
});

// export hooks for usage in functional components
// auto-generated based on the defined endpoints
export const { useGetNewsApiQuery } = newsApi;
